import { render, staticRenderFns } from "./ListingSettingsColumnItem.vue?vue&type=template&id=2b20a15c&scoped=true&"
import script from "./ListingSettingsColumnItem.vue?vue&type=script&lang=js&"
export * from "./ListingSettingsColumnItem.vue?vue&type=script&lang=js&"
import style0 from "./ListingSettingsColumnItem.vue?vue&type=style&index=0&id=2b20a15c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b20a15c",
  null
  
)

export default component.exports